import { DateTime } from "luxon";

export function formatReportDate(date: Date, timezone: string): string {
  return DateTime.fromJSDate(date, { zone: timezone }).toISODate() ?? "";
}
